<template>
    <div class="loan_form">
   
        <b-overlay :show="showoverlaymodal" rounded="sm">
              {{checkPFLimit}}
              <b-form @submit.stop.prevent="onSubmit">
                
                <div class="clearfix border rounded mb-3 mr-3 mb-0 col-md-12">
                    <div class="row justify-content-center"><div class="col-sm-12 mt-1 mb-1 text-center">Total Provident Fund Balance : {{formatMoney(total_pf_balance)}}</div></div>
                </div>
                <div class="clearfix border rounded mb-3 mr-3 mb-0 col-md-12">
                    <div class="row justify-content-center"><div class="col-sm-12 mt-1 mb-1 text-center">Existing Advance Balance : {{formatMoney(existing_loan_balance)}}</div></div>
                </div>
                <b-form-group id="loan_id-group"  v-bind:label="company_id_title" label-for="loan_id">
                    <b-form-input id="loan_id" name="loan_id" :disabled="disableme" v-model="fdata.company_loan_id" v-validate="{ min: 3 }" :state="validateState('loan_id')" aria-describedby="loan_id-feedback" data-vv-as="Company Advance ID"></b-form-input>
                    <b-form-invalid-feedback id="loan_id-feedback">{{ veeErrors.first('loan_id') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="loan_amount-group" v-bind:label="amount_title" label-for="loan_amount">
                    <b-form-input id="loan_amount"  name="loan_amount" :disabled="disableamount == true && paid_amount > 0" v-model="fdata.loan_amount" v-validate="{ required: true }" :state="validateState('loan_amount')" aria-describedby="loan_amount-feedback" data-vv-as="Advance Amount"></b-form-input>
                    <b-form-invalid-feedback id="loan_amount-feedback">{{ veeErrors.first('loan_amount') }}</b-form-invalid-feedback>
                    <div class="invalid-feedback" style="display:block !important;" v-if="this.pf_loan_form_disable==true">The Advance Amount must be less or equal to the total provident fund balance</div>
                    <div style="min-height:30px;"> 
                        <div v-show="disable_submit_amount==true" class="mb-1"  style="font-size: 80% !important; color: #e3342f !important" id="submit-disable">Advance amount is invalid</div>
                    </div>
                </b-form-group>

                <b-form-group id="paid_amount-group" v-bind:label="paid_amount_title" label-for="paid_amount" v-show="edit_form==1 &&  disableamount == true && paid_amount > 0">
                    <b-form-input id="paid_amount"  name="paid_amount" :disabled="disableme" v-model="fdata.paid_amount" ></b-form-input>
                </b-form-group>

                <b-form-group id="remaining_amount-group" v-bind:label="remaining_amount_title" label-for="remaining_amount" v-show="edit_form==1 &&  disableamount == true && paid_amount > 0">
                    <b-form-input id="remaining_amount"  name="remaining_amount" :disabled="disableme" v-model="fdata.remaining_amount" ></b-form-input>
                </b-form-group>

                <b-form-group id="effective_date_of_loan-group" v-bind:label="effective_date_title" label-for="effective_date_of_loan">
                    <b-input-group class="mb-3">
                        <b-input-group-append>
                            <b-form-input id="effective_date_of_loan_text"  :disabled="disableme" name="effective_date_of_loan_text" v-model="fdata.effective_date_of_loan" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('effective_date_of_loan_text')" aria-describedby="effective_date_of_loan_text-feedback" data-vv-as="Effective Date of Advance"></b-form-input>
                            <b-form-datepicker id="day_one" @input="getAvailableMonths(fdata.effective_date_of_loan)" button-only right locale="en-US" :min="date_min" :disabled="disableme"   v-model="fdata.effective_date_of_loan"></b-form-datepicker>
                        </b-input-group-append>
                        <b-form-invalid-feedback id="effective_date_of_loan_text-feedback">{{ veeErrors.first('effective_date_of_loan_text') }}</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
                
                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                <b-form-group id="is_appear_in_payslip-group"  label="Appear in Payslip" label-for="is_appear_in_payslip">
                    <b-form-radio  name="is_appear_in_payslip"  :disabled="disableme"  v-model="fdata.is_appear_in_payslip" v-validate="{ required: true}" :state="validateState('is_appear_in_payslip')" aria-describedby="is_appear_in_payslip-feedback" data-vv-as="Appear in Payslip ?"  value=1>Yes</b-form-radio>
                    <b-form-radio name="is_appear_in_payslip"  :disabled="disableme"  v-model="fdata.is_appear_in_payslip" v-validate="{ required: true}" :state="validateState('is_appear_in_payslip')" aria-describedby="is_appear_in_payslip-feedback" data-vv-as="Appear in Payslip ?"  value=0>No</b-form-radio>
                    <b-form-invalid-feedback id="is_appear_in_payslip-feedback">{{ veeErrors.first('is_appear_in_payslip') }}</b-form-invalid-feedback>
                </b-form-group>
                </template>
                                    
                <b-form-group id="custom_amount-group" v-bind:label="custom_payment_title"  label-for="custom_amount" v-show="is_custom_payment==1">
                    <b-form-input id="custom_amount" name="custom_amount"  v-model="custom_amount" v-validate="{ required: true}" :state="validateState('custom_amount')" aria-describedby="custom_amount-feedback" data-vv-as="Custom Payment Amount"></b-form-input>
                    <b-form-invalid-feedback id="custom_amount-feedback">{{ veeErrors.first('custom_amount') }}</b-form-invalid-feedback>
                    <div style="min-height:30px;">
                        <div class="invalid-feedback" style="display:block !important;"  v-show="disable_submit_new==true"   id="submit-disable">* Manual Payment amount must be less or equal to total outstanding payable amount. </div>
                    </div>
                </b-form-group>
                <b-form-group id="change-next-deduction-month-group" v-show="edit_form==1" >
                <b-form-checkbox id="checkbox-1" v-model="change_deduction_trigger" name="change_deduction" value=1 unchecked-value=0 >
                Change Next Deduction Month
                </b-form-checkbox>
                </b-form-group>
                <b-form-group id="change-remaining-tenure-group" v-show="edit_form==1">
                <b-form-checkbox id="checkbox-2" v-model="change_tenure_trigger"  name="change_tenure" value=1 unchecked-value=0  v-show="edit_form==1">
                Change Remaining Tenure
                </b-form-checkbox>
                </b-form-group>
                <b-form-group id="deduction_start_month-group" v-bind:label="deduction_start_month_title" label-for="deduction_start_month" v-show="edit_form==0">
                    <b-form-select id="deduction_start_month"    :disabled="deduction_start" name="deduction_start_month" v-model="fdata.deduction_start_month" :options="m_lists" v-validate="{ required: true }" :state="validateState('deduction_start_month')" aria-describedby="deduction_start_month-feedback" data-vv-as="Advance Deduction Start Month"></b-form-select>
                    <b-form-invalid-feedback id="deduction_start_month-feedback">{{ veeErrors.first('deduction_start_month') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="next_installment_month-group"  v-bind:label="deduction_start_month_title" label-for="next_installment_month" v-show="edit_form==1">
                    <b-form-select id="next_installment_month" @change="changeDateAndTenure()"   :disabled="change_deduction" name="next_installment_month" v-model="fdata.next_installment_month" :options="m_list_2" v-validate="{ required: true }" :state="validateState('next_installment_month')" aria-describedby="next_installment_month-feedback" data-vv-as="Advance Deduction Start Month"></b-form-select>
                    <b-form-invalid-feedback id="next_installment_month-feedback">{{ veeErrors.first('next_installment_month') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="loan_tenure-group" v-bind:label="tenure_title" label-for="loan_tenure" v-show="edit_form==0">
                    <b-form-input class = "d-inline-block mr-2 align-middle"   style = "width :75%" id="range-1" v-model="fdata.loan_tenure" type="range" min="1" :max="300" v-validate="{ required: true }" :state="validateState('loan_tenure')" aria-describedby="loan_tenure-feedback" data-vv-as="Advance repayment tenure"></b-form-input>
                    <div class="d-inline-block p-1 border align-middle"> {{ fdata.loan_tenure }} Month(s) </div><div class="d-inline-block p-1 border align-middle"><template v-show="company_pf_settings.pf_loan_installment.opt_value == 'plus_one'"> + 1* </template></div>
                    <b-form-invalid-feedback id="loan_tenure-feedback">{{ veeErrors.first('loan_tenure') }}</b-form-invalid-feedback> 
                </b-form-group>
                <b-form-group id="remaining_tenure-group" v-bind:label="tenure_title" label-for="remaining_tenure" v-show="edit_form==1">
                    <b-form-input @change="changeDateAndTenure()"   class = "d-inline-block mr-2 align-middle" :disabled="change_tenure" style = "width :75%" id="range-1" v-model="fdata.remaining_tenure" type="range" min="1" :max="custom_tenure_limit" v-validate="{ required: true }" :state="validateState('remaining_tenure')" aria-describedby="remaining_tenure-feedback" data-vv-as="Advance repayment tenure"></b-form-input>
                    <div class="d-inline-block p-1 border align-middle"> {{ fdata.remaining_tenure }} Month(s) </div><div class="d-inline-block p-1 border align-middle"><template v-show="company_pf_settings.pf_loan_installment.opt_value == 'plus_one'"> + 1* </template></div>
                    <b-form-invalid-feedback id="remaining_tenure-feedback">{{ veeErrors.first('remaining_tenure') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group>
                <template v-if="company_pf_settings.pf_loan_installment.opt_value == 'plus_one'">
                    <div style="display:block !important;" id="submit-plus_one">* One extra installment will be added to selected tenure months as Advance Service Charge. </div>
                </template>
                </b-form-group>
                    
                <a href="javascript:void(0);" v-show="showInstallment==true"  class="btn mb-2 btn-primary btn-full-width"   @click="showInstallments()" >Show Proposed Installments</a>
                <b-form-input  class = "d-inline-block p-1 mr-2 align-middle" disabled style = 'width:48%;display:none !important;' v-model="checkInstallmentamount" name="ins"></b-form-input>
                <b-form-input  class = "d-inline-block p-1 mr-2 align-middle" disabled style = 'width:48%;display:none !important;' v-model="onInstallmentChange" name="onInstallmentChange"></b-form-input>
                <b-form-input  class = "d-inline-block p-1 mr-2 align-middle" disabled style = 'width:48%;display:none !important;' v-model="checkInput" name="onInstallmentChange"></b-form-input>
            
                <div class="mt-1" v-show="show_installment_click==true"> 
                    <div style="min-height:30px;">
                        <div v-show="disable_submit==true && loan_installments.length>0 " class="invalid-feedback" style="display:block !important;"  id="submit-disable">{{remaining_installment_amount}}</div>
                    </div>
                    
                    <div class="" v-for="(row, index) in loan_installments" :key="index">                                 
                        <div class="form-group">
                            <b-form-group id="loan_installments">
                                <div class = "d-inline-block mr-2 align-middle" disabled style = 'width:32%; padding: 6px 6px !important;background: #e9ecef;border-radius: 5px;border: 1px solid #ced4da; color: #495057;' >Installment #{{index+1}}</div>
                                <b-form-input class = "d-inline-block p-1 mr-2 align-middle" disabled style = 'width:32%;' v-model="loan_installments[index].month"></b-form-input>
                                <b-form-input class = "d-inline-block p-1  align-middle" style = 'width:32%;' :name="'installment_'+index" v-model="loan_installments[index].amount" v-validate="{ required: true }" :state="validateState('installment_'+index)" :aria-describedby="'installment_'+index" data-vv-as="Custom Payment Amount"></b-form-input>
                                <b-form-invalid-feedback :id="'installment_'+index">{{ veeErrors.first('installment_'+index) }}</b-form-invalid-feedback>  
                            </b-form-group>  
                        </div>                                 
                    </div> 
                </div>
                <b-form-group id="status-group" v-bind:label="status_title" label-for="status"  v-show="is_custom_payment != 1">
                    <b-form-select id="status" name="status" v-model="fdata.status" :options="loan_status" v-validate="{ required: true }" :state="validateState('status')" aria-describedby="status-feedback" data-vv-as="Advance Status"></b-form-select>
                    <b-form-invalid-feedback id="status-feedback">{{ veeErrors.first('status') }}</b-form-invalid-feedback> 
                </b-form-group>

                <b-form-group id="details-group" v-bind:label="details_title" label-for="loan_details" v-show="is_custom_payment != 1" >
                    <b-form-textarea id="loan_details" placeholder="Enter something..." rows="3" max-rows="6"  v-model="fdata.details"  v-validate="{ required: false }" :state="validateState('loan_details')" aria-describedby="loan_details-feedback" data-vv-as="Advance Details"></b-form-textarea>
                    <b-form-invalid-feedback id="loan_details-feedback">{{ veeErrors.first('loan_details') }}</b-form-invalid-feedback>
                </b-form-group>
                
                <b-button class = "mt-1" type="submit" :disabled="disable_submit_all" variant="primary">Submit</b-button>
            </b-form>

        </b-overlay>               

    </div>

</template>
<script>

    var moment = require('moment');
    const numFormatter = new Intl.NumberFormat('en-US', {
    style: "decimal",
    maximumFractionDigits: 2
    })
    export default{
        
        mounted() {
             
        },
        props: ['pageurl','bn','flg','employee_id','employee_name','count','loan_id','is_custom','is_status'],
        data(){   
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const minDate = new Date(today);

            return {
                date_min:minDate,
                atl_company_package_title: this.$atl_company_package_title,
                successmsg:'',
                deduction_start : true,
                edit_change_click : false,
                loan_stat_title: ["Declined","Applied","Approved","Pause/Stopped","Returned"],
                loan_stat_div: ["text-danger","text-info","text-success","text-muted","text-purple"],
                default_tenure: [0,12,1],
                showoverlay_list : false,       
                disableme: false,    
                disableamount:false,
                disable_submit :false,       
                disable_submit_new :false,    
                disable_submit_all :false,     
                disable_submit_amount:false,
                successmsg:'',
                errormsg:[],
                remaining_amount_money : 0,
                loan_installments:[],
                selected_bank_id:0,
                loading:'',
                is_custom_payment :0,
                loan_title:'',
                company_title:'',
                remaining_installment_amount:0,
                modal_title: '',
                company_id_title : '',
                amount_title: '',
                deduction_start_month_title:'',
                effective_date_title :'',
                status_title : '',
                showoverlaymodal : false,
                change_tenure : true,
                change_deduction : true,
                change_tenure_trigger : 0,
                change_deduction_trigger : 0,
                showInstallment:false,
                show_installment_click :false,
                details_title: '',
                tenure_title:'',
                loan_entity_id:'',
                loan_update_status:'',
                loan_type: 1,
                loan_type_title: 'Process Type',
                loan_type_select: 1,
                edit_form : 0,
                loan_tenure_new:0,
                custom_amount : 0,
                custom_tenure_limit:0, 
                tenure_length_edit :'',
                custom_payment_title :'Custom Payment Amount',
                paid_amount_title: 'Paid Amount',
                paid_amount:0,
                remaining_amount_title:'Remaining Amount',
                loan_types_drop : ['','Loan','Advance'],
                loan_status:[
                    { value: null, text: "Select..." },
                    { value: "0", text: "Decline" },
                    { value: "1", text: "Applied" },
                    { value: "2", text: "Approve" },
                    { value: "3", text: "Pause/Stop" },
                ],
                loan_type_vals:[
                    { value: "1", text: "Loan" },
                    { value: "2", text: "Advance" },

                ],
                company_pf_settings:{pf_loan_installment:{opt_value:0}},
                fdata : {company_loan_id:'', employee_id:'',installments:[], loan_amount:'',loan_type:'',effective_date_of_loan:null ,deduction_start_month:null , core_hr:'' , loan_tenure:'',details:'',status:2,next_installment_month:'',paid_amount:'',change_deduction:"No",change_tenure:"No",paid_tenure:0,remaining_tenure:0,remaining_amount:'',custom_amount:0,core_hr:null},
                m_lists : [],
                m_list_2 : [],
                installment2 : [],
                no_installment : true,
                pf_contribution :0,
                pf_loan_form_disable:false,
                last_payrun_month:'',
                total_pf_balance:0,
                existing_loan_balance:0,
            }
        },
        methods:{
            
            showInstallments()
            {
                this.show_installment_click = true;
            },
            editLoanInfo:function(x,type)
            {        
                this.showoverlaymodal = true;
                if(!this.checkNet()) return false;

                    if(type==0)
                    {
                        this.resetForm();
                        this.is_custom_payment =0;
                    }
                    if(type==1)
                    {
                        this.resetForm();
                        this.is_custom_payment =1;
                    }
                    axios.get(this.$api_url+'/pf/loan/edit' , {
                        params: {
                            id: x 
                        }
                    })
                    .then(function(response){
                        this.edit_change_click = false;
                        this.fdata = response.data;
  
                        
                        /***** */
                        if(this.fdata.loan_amount != this.fdata.remaining_amount)
                        {
                            this.loan_status = [{ value: null, text: "Select..." },{ value: "2", text: "Approve" },{ value: "3", text: "Pause/Stop" }];
                        }

                        this.disableamount = true;
                        if(this.fdata.status==1)
                        {
                           this.loan_status =  [{ value: null, text: "Select..." },{ value: "0", text: "Decline" },{ value: "1", text: "Applied" },{ value: "2", text: "Approve" }];
                           this.disableamount = false;
                        
                        }
                        this.paid_amount = this.fdata.paid_amount;
                        this.fdata.loan_amount =  this.formatMoney(this.fdata.loan_amount);
                        this.fdata.paid_amount =  this.formatMoney(this.fdata.paid_amount);
                        this.remaining_amount_money  = this.fdata.remaining_amount;
                        this.fdata.remaining_amount =  this.formatMoney(this.fdata.remaining_amount);

                        /***** */
                        this.fdata.custom_amount = 0;
                        this.custom_amount = 0;
                        this.loan_installments = this.fdata.installments; 

                        if(this.loan_installments.length>0) 
                        {
                            for(let i = 0; i<this.loan_installments.length; i++)
                            {
                                this.loan_installments[i].amount = this.formatMoney(this.loan_installments[i].amount);
                            }

                        }
                        this.loan_type = this.fdata.loan_type;  
                        // this.custom_tenure_limit = this.fdata.remaining_tenure
                        this.custom_tenure_limit = 300;
                        this.edit_form = 1;
                        this.setFormtitle(this.loan_type);
                        this.successmsg = null;
                        this.disableme = true;
                        if(this.fdata.paid_amount ==0)
                        {
                            this.disableme = false;
                            this.custom_tenure_limit = 300;
                        }
                        this.disable_submit =false;
                        this.disable_submit_all =false;
                        this.disable_submit_new =false;
                        this.disable_submit_amount =false;
                        

                        this.change_tenure_trigger = 0,
                        this.change_deduction_trigger = 0,
                        this.pf_loan_form_disable=false;
                        this.pf_contribution = 0,
                        this.employee_id = this.fdata.employee_id;
                        this.getLastPayrun(this.employee_id);
                        this.getAvailablePf();
                        this.getInstallments();
                        //this.getAvailableMonths(this.fdata.effective_date_of_loan);

                        
                        this.getNextAvailableMonths();
                        this.loan_tenure_new = this.fdata.remaining_tenure;
                        this.deduction_start_month_title = 'Next Deduction Month'; 
                        this.tenure_title = 'Remaining Repayment Tenure'; 

                        var paid_amount = this.toMoney(this.fdata.paid_amount);

                        if(paid_amount>0 || this.is_custom_payment==1)
                        {
                            this.no_installment = false;
                            this.disableamount = true;
                        }

                        if(this.is_status != 0)
                        {
                            this.fdata.status = this.is_status;
                        }

                        this.showoverlaymodal = false;

                    }.bind(this)).catch(function (error){alert(error)});

                
                
            },   
            resetForm()
            {     
                this.pf_contribution = 0;
                this.no_installment = true;
                this.edit_change_click = false;
                this.show_installment_click = false;
                this.deduction_start = true;
                this.disable_submit =false;
                this.disable_submit_all =false;
                this.disable_submit_amount =false;
                this.disable_submit_new =false;
                this.showInstallment = false; 
                this.disableme = false;
                this.disableamount = false,
                this.loan_tenure_new =0;
                this.loan_installments = [];
                this.edit_form =0;
                this.custom_amount =0; 
                this.is_custom_payment = 0;
                this.tenure_length_edit =0;
                this.change_tenure_trigger = 0,
                this.change_deduction_trigger = 0,
                this.setFormtitle(this.loan_type);
                this.fdata = {company_loan_id:'', employee_id:this.employee_id, loan_amount:'',installments:[],remaining_amount: null,next_installment_month:'',loan_type:this.loan_type, effective_date_of_loan:'' , deduction_start_month:null , loan_tenure:this.default_tenure[this.loan_type],details:'',status:2,paid_amount:'',paid_tenure:0,remaining_tenure:0,remaining_amount:'',change_deduction:"No",change_tenure:"No",custom_amount:0,core_hr:"1"};
                this.$nextTick(() => {
                    this.$validator.reset();
                });

            },  
            changeDateAndTenure()
            {
                this.edit_change_click = true;
            },
            getAvailableMonths(date)
            {
                axios.get(this.$api_url+'/pf/get-last-payrun', {
                    params: {
                    employee_id:this.employee_id,
                    effective_date:date
                    }
                    }).then(function(response)
                    { 
                         var m_names = ['January', 'February', 'March', 
                                'April', 'May', 'June', 'July', 
                                'August', 'September', 'October', 'November', 'December'];
                        /** Get Last Payrun Date **/

                        this.last_payrun_month = response.data;

                        var last_payrun_month_2 = this.last_payrun_month;
                        const str_month_arr_2 = last_payrun_month_2.split("-");
                        var payrun_year   = parseInt(str_month_arr_2[1]);
                        var p_month  = str_month_arr_2[0]; 
                        var payrun_month = m_names.indexOf(p_month);
                        var dt1   = 1;
                        const payrun_date = new Date(payrun_year,payrun_month,dt1);
                        payrun_date.setMonth(payrun_date.getMonth()+1);
                        this.date_min = payrun_date;
                        if(!this.edit_form)
                        {
                            var m_names = ['January', 'February', 'March', 
                                        'April', 'May', 'June', 'July', 
                                        'August', 'September', 'October', 'November', 'December'];

                          
                            //this.fdata.deduction_start_month = null;
                            var yr1   = parseInt(date.substring(0,4));
                            var mon1  = parseInt(date.substring(5,8)); 
                            var dt1   = parseInt(date.substring(8,10));
                            var all_months = [];
                            
                            all_months.push({value: null,text: "Select..."}); 
                            let mt =0;
                            console.log(payrun_date);
                            for (let i = 1; i <= 24;) 
                            { 
                                var d = new Date(yr1, mon1-1, dt1);
                                if(d.getDate()>27)
                                {
                                    d.setDate(d.getDate() - 5);
                                }
                                d.setMonth(d.getMonth() + mt);


                                if(d.getTime() >= payrun_date.getTime())
                                {
                                    var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();
                                    all_months.push({value: fullText,text:fullText});
                                    i++;
                                
                                }
                                
                                mt++;
                        
                            }
                            
                            if(all_months.length>=24)
                            {
                                this.m_lists =  all_months;
                                this.deduction_start = false;
                            }
                        }
                        if(this.edit_form)
                        {
                        

                            //this.fdata.deduction_start_month = null;
                            var yr1   = parseInt(date.substring(0,4));
                            var mon1  = parseInt(date.substring(5,8)); 
                            var dt1   = parseInt(date.substring(8,10));
                            var all_months = [];
                            all_months.push({value: null,text: "Select..."}); 
                            let mt =0;
                            for (let i = 1; i <= 24;) 
                            { 
                                
                                var d = new Date(yr1, mon1-1, dt1);
                                
                                if(d.getDate()>27)
                                {
                                    d.setDate(d.getDate() - 5);
                                }
                                d.setMonth(d.getMonth() + mt);

                                if(d.getTime() >= payrun_date.getTime())
                                {
                                    var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();
                                    all_months.push({value: fullText,text:fullText});
                                    if(i==1)
                                    {
                                        this.fdata.next_installment_month = fullText;
                                        //this.getInstallments();
                                    } 
                                    
                                    i++;
                                
                                }
                                
                                mt++;
                            }
                            
                            if(all_months.length>=24)
                            {
                                this.m_list_2 =  all_months;
                            }

                        }
                    }.bind(this));

            },  
            getNextAvailableMonths()
            {
                
                axios.get(this.$api_url+'/pf/get-last-payrun' , {
                    params: {
                       employee_id:this.employee_id
                    }
                }).then(function(response){

                    this.last_payrun_month = response.data;
                if(this.edit_form)
                { 


                    var m_names = ['January', 'February', 'March', 
                            'April', 'May', 'June', 'July', 
                            'August', 'September', 'October', 'November', 'December'];
                    var all_months = [];

                 if(this.paid_amount==0)
                {
                    if(this.paid_amount==0)
                    {
                        var date  = this.fdata.effective_date_of_loan;
                        var yr1   = parseInt(date.substring(0,4));
                        var mon1  = parseInt(date.substring(5,8)); 
                        mon1 = mon1-1;
                        var dt1   = parseInt(date.substring(8,10));
                        var d = new Date(yr1, mon1, dt1);
                        var last_payrun_month_2 = this.last_payrun_month;
                        const str_month_arr_2 = last_payrun_month_2.split("-");
                        var payrun_year   = parseInt(str_month_arr_2[1]);
                        var p_month  = str_month_arr_2[0]; 
                        var payrun_month = m_names.indexOf(p_month);
                        var dt2   = 1;
                        const payrun_date = new Date(payrun_year,payrun_month,dt2);
                        payrun_date.setMonth(payrun_date.getMonth()+1);
                        var date_check = Date.parse(payrun_date) > Date.parse(d);
                        var no_install = true;
                        var p_date = payrun_date;
                        console.log(date_check);
                        console.log(p_date);
                        console.log(p_date.toString().slice(0, 10));


                        if(date_check)
                        {
                            this.fdata.effective_date_of_loan = '';
                            this.fdata.deduction_start_month = '';
                            this.fdata.next_installment_month = null;
                            this.m_list_2 = [];
                            
                        }

                    
                    



                    }
                }
                else
                {

                    var start_month = this.fdata.next_installment_month;
                    const str_month_arr = start_month.split("-");
                    var yr1   = parseInt(str_month_arr[1]);
                    var mt  = str_month_arr[0]; 
                    var mon1 = m_names.indexOf(mt);
                    var dt1   = 1;
                    var current_date = new Date();
                    var d1 = new Date(yr1, mon1);
                    var d2 = new Date(current_date.getFullYear(), current_date.getMonth());    // 02/2014
                    var date_check = Date.parse(d2) > Date.parse(d1);
                    var no_install = false;
                    
                    if(this.fdata.remaining_tenure == this.fdata.loan_tenure || paid_amount > 0)
                    {
                        no_install = true;
                        
                    } 
                    console.log('d1');
                    console.log(d1);
                    console.log('date_check');
                    console.log(date_check);
  
                    if(date_check==true)
                    {
                        this.loan_installments = [];
                        this.fdata.installments = [];
                        for (let i = 0; i < 24;)  
                        { 
                            var d = new Date();
                            if(d.getDate()>27)
                            {
                                d.setDate(d.getDate() - 5);
                            }
                            d.setMonth(d.getMonth() + i);
                            var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();
                            if(i==0)
                            {
                                this.fdata.next_installment_month = fullText;
                                //this.getInstallments();
                            } 
                            all_months.push({value: fullText,text:fullText});
                            i++;
                        }
                        
                    }
                    
                    else
                    {
                        for (let i = 0; i < 24;)  
                        { 
                            var d = new Date(yr1, mon1, dt1);
                            if(d.getDate()>27)
                            {
                                d.setDate(d.getDate() - 5);
                            }
                            d.setMonth(d.getMonth() + i);
                            var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();

                            all_months.push({value: fullText,text:fullText});
                            i++;
                        }

                    }

                    
                    
                    if(all_months.length>=24)
                    {
                        this.m_list_2 =  all_months;
                    }
                }
                }
                }.bind(this));

            },
            selecetedLoanType:function()
            {
                this.loan_type = this.loan_type_select;
                this.addNewLoan(this.loan_type);
            }, 
            validateState(ref)
            {
                if ( this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated) ) 
                {

                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            setFormtitle:function(x)
            {
                
                   //alert('here');
                   
                   this.loan_title = 'PF Advance List';
                    this.company_id_title = 'PF Advance ID';
                    this.amount_title = 'Advance Amount';
                    this.deduction_start_month_title = 'Advance Deduction Start Month';
                    this.effective_date_title = 'Effective Date of Advance';
                    this.status_title = 'Advance Status';
                    this.details_title= 'Advance Details';
                    if(this.edit_form==1)
                    {
                        this.modal_title = 'Edit Advance';
                    }
                    else
                    {
                        this.modal_title = 'Process Advance';
                    } 
                    if(this.is_custom_payment)
                    {
                        this.modal_title = 'Custom Payment';
                    }
                    this.tenure_title = 'Advance repayment tenure';
                
                
            },  
            addNewLoan:function(x)
            {
                 
                 //alert("hegeegeefefef");
                 this.resetForm();
                 this.loan_status = [{ value: null, text: "Select..." },{ value: "1", text: "Applied" },{ value: "2", text: "Approve" }];
            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // }, 
            toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, ''); 
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return amount;
            },
            getInstallments()
            {
                
                var m_names = ['January', 'February', 'March', 
                        'April', 'May', 'June', 'July', 
                        'August', 'September', 'October', 'November', 'December'];
                var all_months = [];
                var all_amounts = [];
                var installments = [];
                var generate = 0;

                if(!this.edit_form)
                {
                    console.log("HERE 1");
                    var pattern = /^(0|[1-9][0-9]{0,2}(?:(,[0-9]{3})*|[0-9]*))(\.[0-9]+){0,1}$/;
                    //if(pattern.test(this.fdata.loan_amount))
                    if(1)
                    {
                        var loan_tenure = parseInt(this.fdata.loan_tenure);
                        var start_month = this.fdata.deduction_start_month; 
                        var loan_amount = this.toMoney(this.fdata.loan_amount);
                        if(loan_amount==0)
                        {
                            this.disable_submit_amount =true;
                            generate =0;
                        }
                        else
                        {
                            this.disable_submit_amount =false;
                            loan_amount = Math.round(loan_amount * 100) / 100;
                            generate =1;

                        }

                    }
                    else
                    {
                        this.disable_submit_amount =true;
                        generate =0;
                    }
                    
                }
                if(this.edit_form && this.paid_amount == 0 && this.fdata.custom_amount == 0)
                {
                    console.log("HERE 1");
                    var loan_amount = this.toMoney(this.fdata.loan_amount);
                    var remaining_amount = this.toMoney(this.fdata.remaining_amount);
                    var start_month = this.fdata.next_installment_month; 
                    var prev_start_month = this.fdata.deduction_start_month; 

                    if(this.change_tenure == true && this.change_deduction== true && loan_amount==remaining_amount && start_month==prev_start_month )
                    {
                        console.log("HERE 2");
                        generate = 2;
                        let co = [];          
                        this.loan_installments = [];
                        this.loan_installments = this.fdata.installments;
                        this.fdata.installments.forEach(element => {
                            co = co.concat([{ month: element.month , amount: element.amount }]);
                        });
                        this.loan_installments = co;
                        
                    }
                    else
                    {
                        console.log("HERE 3");
                        var loan_tenure = parseInt(this.fdata.remaining_tenure);
                        
                        var loan_amount = this.toMoney(this.fdata.loan_amount);
                        if(loan_amount==0)
                        {
                            this.disable_submit_amount =true;
                            generate =0;
                        }
                        else
                        {
                            this.disable_submit_amount =false;
                            loan_amount = Math.round(loan_amount * 100) / 100;
                            generate =1;
                        }

                    }
                    
                }
                else if(this.fdata.installments.length==0 && this.edit_form==1)
                {
                    var loan_tenure = parseInt(this.fdata.remaining_tenure);
                    var start_month = this.fdata.next_installment_month;
                    if(this.disableamount == false)
                    {
                        
                        var remaining_amount  =  this.toMoney(this.fdata.loan_amount);
                        remaining_amount = Math.round(remaining_amount * 100) / 100;
                    }
                    else
                    {
                        var remaining_amount  =  this.toMoney(this.fdata.remaining_amount);
                        remaining_amount = Math.round(remaining_amount * 100) / 100;
                    }
                    var custom_amount  =  this.toMoney(this.fdata.custom_amount);
                    custom_amount = Math.round(custom_amount * 100) / 100;
                    var loan_amount = remaining_amount-custom_amount;


                    if(loan_amount>0)
                    {   
                        if(loan_tenure == 0)
                        {
                            
                            loan_tenure = this.loan_tenure_new;
                            this.fdata.remaining_tenure = this.loan_tenure_new;
                        }
                        
                        generate =1;
                        this.disable_submit_new = false;
                    } 
                    
                    if(loan_amount==0)
                    {

                        this.fdata.remaining_tenure = 0;
                        this.loan_installments = [];
                        this.disable_submit_new = false;
                    }
                    if(loan_amount<0)
                    {
                        this.fdata.remaining_tenure = 0;
                        this.loan_installments = [];
                        this.disable_submit_new = true;
                    }     
                    if(this.is_custom && custom_amount==0)
                    {
                        this.disable_submit_new = true;
                    }          

                }
                else if ((this.edit_form && this.edit_change_click == true) || (this.edit_form && this.fdata.custom_amount > 0))
                {
                    console.log("HERE 3");
                    var loan_tenure = parseInt(this.fdata.remaining_tenure);
                    var start_month = this.fdata.next_installment_month;
                    
                    if(this.disableamount == false)
                    {
                        
                        var remaining_amount  =  this.toMoney(this.fdata.loan_amount);
                        remaining_amount = Math.round(remaining_amount * 100) / 100;
                    }
                    else
                    {
                        var remaining_amount  =  this.toMoney(this.fdata.remaining_amount);
                        remaining_amount = Math.round(remaining_amount * 100) / 100;
                    }
                    
                    var custom_amount  =  this.toMoney(this.fdata.custom_amount);
                    custom_amount = Math.round(custom_amount * 100) / 100;
                    
                    
                    var loan_amount = remaining_amount-custom_amount;
                    
                    if(loan_amount>0)
                    {   
                        if(loan_tenure == 0)
                        {
                            loan_tenure = this.loan_tenure_new;
                            this.fdata.remaining_tenure = this.loan_tenure_new;
                        }
                        
                        generate =1;
                        this.disable_submit_new = false;
                    } 
                    
                    if(loan_amount==0)
                    {
                        this.fdata.remaining_tenure = 0;
                        this.disable_submit_new = false;
                        this.loan_installments = [];
                    }
                    if(loan_amount<0)
                    {
                        this.disable_submit_new = true;
                        this.loan_installments = [];
                        this.fdata.remaining_tenure = 0;
                    }
                    if(this.is_custom && custom_amount==0)
                    {
                        this.disable_submit_new = true;
                    }  
                    
                }
                else if(this.edit_form && this.change_tenure == true && this.change_deduction== true)
                {
                    console.log("HERE 4");
                    generate = 2;

                    // if(this.fdata.status==1)
                    // {
                    //     //     generate = 1;
                    //     //  console.log("HERE 4 - "+ generate);
                    // } 
                    
                    
                }

                if(generate==1)
                {
                    const str_month_arr = start_month.split("-");
                    var yr1   = parseInt(str_month_arr[1]);
                    var mt  = str_month_arr[0]; 
                    var mon1 = m_names.indexOf(mt);
                    var dt1   = 1; 
                    for (let i = 0; i < loan_tenure;i++) 
                    {
            
                        var d = new Date(yr1, mon1, dt1);
                        d.setMonth(d.getMonth() + i);
                        var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();
                        all_months.push(fullText);
                        
                    }

                    if(all_months.length==loan_tenure)
                    {   
                        loan_amount = Math.round(loan_amount * 100) / 100;
                        var frac_month_amount = Math.floor(loan_amount/loan_tenure);
                        var round_amount = frac_month_amount*loan_tenure;
                        var extra_amount = loan_amount - round_amount;
                        for (let i = 0; i < loan_tenure;i++) 
                        {
                            if(i==0)
                            {
                                all_amounts.push(frac_month_amount+extra_amount);
                                continue;
                            }   
                            all_amounts.push(frac_month_amount);
                        } 

                        if(all_amounts.length==loan_tenure)
                        { 
                            var ct = 0;
                            for (let i = 0; i < loan_tenure;i++) 
                            { 
                                if(all_amounts[i]<=0)
                                {
                                    ct++;
                                    continue;
                                }

                                installments.push({month: all_months[i],amount:all_amounts[i]});
                                ct++;
                            }
                        }

                        if(loan_tenure==ct)
                        {
                            if(installments.length!=loan_tenure)
                            {
                                if(installments.length==0 && this.edit_form)
                                {
                                    this.fdata.remaining_tenure = 0;
                                }
                                else if(!this.edit_form)
                                {
                                    this.fdata.loan_tenure = installments.length;
                                }
                                else if(this.edit_form)
                                {
                                    this.fdata.remaining_tenure = installments.length;
                                }
                            }


                            if(installments.length>0)
                            {
                                for(let i = 0; i<installments.length; i++)
                                {
                                    installments[i].amount = this.formatMoney(installments[i].amount);
                                } 

                            }
                            this.loan_installments = installments;
                        }
                    }
                }
            },
            onSubmit(e) 
            {   
                if(!this.checkNet()) return false;
                
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    
                    e.preventDefault();  
                    let currentObj = this;
                    currentObj.errormsg = '';
                    this.showoverlaymodal = true;
                    let formData = new FormData();
                    this.fdata.installments = [];
                    /***** */
                    var pattern = /^(0|[1-9][0-9]{0,2}(?:(,[0-9]{3})*|[0-9]*))(\.[0-9]+){0,1}$/;
                    //if(pattern.test(this.fdata.loan_amount ))
                    if(1)
                    {
                        this.fdata.loan_amount =  this.toMoney(this.fdata.loan_amount);
                        this.fdata.loan_amount =  Math.round(this.fdata.loan_amount  * 100) / 100;
                    }
                    else
                    {
                        alert("Amount is invalid");
                        return 0;
                    }
                    
                    this.fdata.paid_amount =  this.toMoney(this.fdata.paid_amount);
                    this.fdata.paid_amount =  Math.round(this.fdata.paid_amount  * 100) / 100;
                    this.fdata.remaining_amount =  this.toMoney(this.fdata.remaining_amount);
                    this.fdata.remaining_amount =  Math.round(this.fdata.remaining_amount  * 100) / 100;
                    if(this.fdata.remaining_tenure == this.fdata.loan_tenure)
                    {
                        this.fdata.deduction_start_month = this.fdata.next_installment_month;
                    }
                    

                    if(this.loan_installments.length)
                    { 
                        var installs = 0;
                        for(let i = 0; i<this.loan_installments.length; i++)
                        {
                            installs = this.toMoney(this.loan_installments[i].amount);
                            installs =  Math.round(installs  * 100) / 100;
                            this.loan_installments[i].amount = installs;
                        }
                        this.fdata.installments = JSON.stringify(this.loan_installments);
                    }
                
                    /**** */
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                    } 

                    this.showoverlay = true;
                    axios.post(this.$api_url+'/pf/loan/save', formData)
                        .then(function (response) 
                        {
                            
                            this.$bvToast.toast("Saved!", {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                            var data = this.fdata.employee_id;
                            this.$emit('childToParent'); 
                            //this.resetForm();
                            this.showoverlay = false;
                            this.showoverlaymodal = false;
                             
                        }.bind(this))
                        .catch(function (error) 
                        {           
                            currentObj.showoverlay = false;
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;                                    
                            for (var data in currentObj.errormsg)
                            {
                                var msg = currentObj.errormsg[data];
                                currentObj.$bvToast.toast(msg, {
                                    title: `Error`,
                                    variant: 'danger',
                                    solid: true
                                }); 
                                currentObj.$validator.reset(); 
                            } 
                        });
                });
            },
            getLastPayrun: function(id)
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/pf/get-last-payrun' , {
                    params: {
                       employee_id:id
                    }
                }).then(function(response){
                    console.log(response.data);
                    this.last_payrun_month = response.data;


                    var m_names = ['January', 'February', 'March', 
                                'April', 'May', 'June', 'July', 
                                'August', 'September', 'October', 'November', 'December'];

                    /** Get Last Payrun Date **/
                    var last_payrun_month_2 = this.last_payrun_month;
                    const str_month_arr_2 = last_payrun_month_2.split("-");
                    var payrun_year   = parseInt(str_month_arr_2[1]);
                    var p_month  = str_month_arr_2[0]; 
                    var payrun_month = m_names.indexOf(p_month);
                    var dt1   = 1;
                    const payrun_date = new Date(payrun_year,payrun_month,dt1);
                    payrun_date.setMonth(payrun_date.getMonth()+1);

                    this.date_min = payrun_date;


                    /****/
                }.bind(this));
            },
            
           getcompany: function()
            {
                let formData = new FormData();
                axios.post(this.$api_url + '/company/getcompany', formData)
                .then(function (response) 
                {     
                    this.company_id = response.data;
                    
                    if(this.company_id > 0)           
                        this.getCompanyPFSettings(); 
                }.bind(this));
            },
           getCompanyPFSettings: function()
            {      let currentObj = this;

                
                    let formData = new FormData();
                    axios.post(this.$api_url + '/pf/settings', formData)
                    .then(function (response) 
                    {       
                        if(response.data.data){
                        this.company_pf_settings = response.data.data;
                    }
                }.bind(this));
            },
            getAvailablePf()
            {
                let formData = new FormData();
                formData.append('employee_id', this.employee_id); 
                formData.append('data_front', 'yes');  
                axios.post(this.$api_url+'/pf/employee/available-amount', formData) 
                    .then(function (response) 
                    {    
                        this.total_pf_balance = response.data;
                        this.getExisitingLoanBalance();
                    }.bind(this))
                    .catch(function (error) 
                    {
                        console.log(error);
                    });
            },
            getExisitingLoanBalance()
            {
                let formData = new FormData();
                formData.append('employee_id', this.employee_id); 
                axios.post(this.$api_url+'/pf/employee/loan-balance', formData) 
                    .then(function (response) 
                    {    
                        this.existing_loan_balance = response.data.loan_availed - response.data.loan_returned;

                        this.pf_contribution = this.total_pf_balance - this.existing_loan_balance;

                    }.bind(this))
                    .catch(function (error) 
                    {
                        console.log(error);
                    });
            },
        },
    
        computed: 
        {
            onInstallmentChange()
            {
                if(this.loan_installments.length>0)
                { 
                    //console.log(this.loan_installments);
                    var installment_total = 0;
                    var install_money = 0;
                    var number = 0;
                    for(let i = 0; i< this.loan_installments.length; i++)
                    {
                        install_money = this.toMoney(this.loan_installments[i].amount);
                        number = Math.round(install_money * 100) / 100;
                        installment_total  = installment_total + number;
                        
                    }
                    installment_total = Math.round(installment_total * 100) / 100;
                    var payable_amount = 0;
                    if(this.edit_form)
                    {
                        if(this.disableamount == false)
                        {
                            
                            payable_amount = this.toMoney(this.fdata.loan_amount);
                            payable_amount = Math.round(payable_amount * 100) / 100;
                        }
                        else
                        {
                            payable_amount = this.toMoney(this.fdata.remaining_amount);
                            payable_amount = Math.round(payable_amount * 100) / 100;
                        }
                        
                    }
                    if (this.edit_form && this.is_custom_payment)
                    {
                        if(this.disableamount == false)
                        {
                        
                            payable_amount = this.toMoney(this.fdata.loan_amount) - this.toMoney(this.fdata.custom_amount)
                        }
                        else
                        {
                            payable_amount = this.toMoney(this.fdata.remaining_amount) - this.toMoney(this.fdata.custom_amount)
                        }
                    
                        payable_amount = this.toMoney(payable_amount);
                        payable_amount = Math.round(payable_amount * 100) / 100;
                    }
                    if(!this.edit_form)
                    {
                        payable_amount = this.toMoney(this.fdata.loan_amount);
                        payable_amount = Math.round(payable_amount * 100) / 100;

                    }
                    
                    if(installment_total!=payable_amount)
                    {
                        this.disable_submit = true;
                        this.remaining_installment_amount = payable_amount -installment_total;
                        if (isNaN(this.remaining_installment_amount)) {
                           this.remaining_installment_amount =' *Installment amount must be equal to total payable. Installment field contain invalid value';
                        }
                        else
                        {
                            if(this.remaining_installment_amount> 0)
                            {
                                this.remaining_installment_amount  = this.formatMoney(this.remaining_installment_amount);
                                this.remaining_installment_amount =' *Installment amount must be equal to total payable. Total Installment amount is '+this.remaining_installment_amount+' less than total payable';
                            }
                            if(this.remaining_installment_amount< 0)
                            {
                                this.remaining_installment_amount = this.remaining_installment_amount * (-1);
                                this.remaining_installment_amount  = this.formatMoney(this.remaining_installment_amount);
                                this.remaining_installment_amount =' *Installment amount must be equal to total payable. Total Installment amount is '+this.remaining_installment_amount+' more than total payable';
                            }
                        }
                    } 
                    else
                    {
                        this.disable_submit = false;
                        this.remaining_installment_amount =this.formatMoney(0);
                    }
                } 
            },
            checkInput()
            {
                if(this.disable_submit_new || this.disable_submit || this.disable_submit_amount || this.pf_loan_form_disable)
                {
                    this.disable_submit_all = true;
                }
                else
                {
                    this.disable_submit_all = false;
                }
                
            },
            checkPFLimit()
            {
                let loan_mon = this.toMoney(this.fdata.loan_amount);
                if(loan_mon > this.pf_contribution)
                {
                    this.pf_loan_form_disable =true;
                    if(this.edit_form==1 && this.fdata.status != 1)
                    {
                        this.pf_loan_form_disable =false;
                    }
                }
                else
                {
                    this.pf_loan_form_disable =false;
                }
            },

            checkInstallmentamount() 
            {
               
                if(this.is_custom)
                {

                    var ct_amount = this.toMoney(this.custom_amount);
                    ct_amount = Math.round(ct_amount * 100) / 100;
                    if(isNaN(ct_amount))
                    {
                        this.disable_submit_new = true;
                    }
                    else
                    {   

                    if(ct_amount==0)
                    {
                        this.disable_submit_new = true;
                    }
                    else
                    {
                        this.disable_submit_new = false;
                    }

                    }
                }
                else
                {
                    var ct_amount = 0.00; 
                }
                


                if(this.change_deduction_trigger=="1")
                {   
                    this.change_deduction = false;
                }
                else
                {
                    this.change_deduction = true;
                } 
                if(this.change_tenure_trigger=="1")
                {
                    this.change_tenure = false;
                }
                else
                {
                    this.change_tenure = true;
                }
                //console.log(this.fdata.loan_amount);


                if(this.fdata.loan_tenure > 0 && this.fdata.deduction_start_month != null && this.fdata.loan_amount != '' && this.fdata.effective_date_of_loan != '' && (ct_amount >= 0))
                {
                    
                    if(this.custom_amount === '')
                    {
                        this.fdata.custom_amount = 0;
                    }
                    else
                    {
                        this.fdata.custom_amount = ct_amount;

                    } 
                    console.log('getInstallments');
                    this.getInstallments();
                    
                    this.showInstallment = true;
                    
                } 
                else 
                {
                    this.showInstallment = false; 
                    this.loan_installments = [];
                }

                
            },
        }, 
        created: function(){
            
            this.pf_contribution = 0;
            this.loan_installments = [];
            this.loan_type = 1;
            this.getcompany();
            this.getAvailablePf();
            if(this.loan_id>0)
            {
                this.editLoanInfo(this.loan_id,this.is_custom);
                //alert("here is edit");
            }
            else
            {   
                 //alert("here is add");
                this.getLastPayrun(this.employee_id);
                this.addNewLoan(1);
           }  
           
                if(this.atl_company_package_title == 'Provident Fund Only')
                {
                    this.fdata.is_appear_in_payslip = 1; 
                }

        } 
    }
</script>
